import { createStore, combineReducers, applyMiddleware } from "redux";
import ReduxThunk from "redux-thunk";
// import mainNavigationReducer from "./reducers/mainNavigationReducer";
import projectsReducer from "./reducers/projectsReducer";
import aboutReducer from "./reducers/aboutReducer";
import cookieReducer from "./reducers/cookieReducer";
import toggleNavigationReducer from "./reducers/toggleNavigationReducer";
// import routesReducer from "./reducers/routesReducer";
import downloadsReducer from "./reducers/downloadsReducer";
import taxonomyReducer from "./reducers/taxonomyReducer";
import currentFilterReducer from "./reducers/currentFilterReducer";
import jobsReducer from "./reducers/jobsReducer";
import contactFormReducer from "./reducers/contactFormReducer";
import newsReducer from "./reducers/newsReducer";
import contactReducer from "./reducers/contactReducer";
// import newsTaxonomyReducer from "./reducers/newsTaxonomyReducer";
import selectedNewsReducer from "./reducers/selectedNewsReducer";
import selectedJobReducer from "./reducers/selectedJobReducer";
import selectedProjectReducer from "./reducers/selectedProjectReducer";
import homepageReducer from "./reducers/homepageReducer";
import pageAnimationReducer from "./reducers/pageAnimationReducer";
import { reducer as formReducer } from "redux-form";
import mouseStateReducer from "./reducers/mouseStateReducer";

const rootReducer = combineReducers({
  // mainNavigation: mainNavigationReducer,
  projects: projectsReducer,
  about: aboutReducer,
  cookies: cookieReducer,
  contact: contactReducer,
  navVisible: toggleNavigationReducer,
  // routes: routesReducer,
  downloads: downloadsReducer,
  taxonomy: taxonomyReducer,
  filter: currentFilterReducer,
  jobs: jobsReducer,
  contactForm: contactFormReducer,
  news: newsReducer,
  selectedNews: selectedNewsReducer,
  selectedJob: selectedJobReducer,
  selectedProject: selectedProjectReducer,
  form: formReducer,
  homepage: homepageReducer,
  routeAnimation: pageAnimationReducer,
  mouseState: mouseStateReducer
  // newsTaxonomy:  newsTaxonomyReducer
});

const store = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  applyMiddleware(ReduxThunk)
);
export default store;



// WEBPACK FOOTER //
// ./src/store.js